import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

Vue.http.interceptors.push(function (request) {
  const token = sessionStorage.getItem('AUTH_TOKEN') || localStorage.getItem('AUTH_TOKEN')
  const publicAction = (new URL(request.url)).pathname.indexOf('/public_action') === 0
  const allowRequest = Boolean(token) || publicAction || Boolean(request.url === 'https://api.sonar.cloud/user_token') || Boolean(request.url.includes('https://api.sonar.cloud/user_token_uuid'))

  if (allowRequest) {
    if (!request.doNotAddBearerToken) {
      if (request.url.includes('https://barrysbootcamp.marianatek.com')) {
        request.headers.set('Authorization', `Bearer ${localStorage.getItem('mt_access_token')}`)
      } else if (request.url.includes('https://api.sonar.cloud')) {
        request.headers.set('Authorization', `Bearer ${token}`)
      }
    }
  } else {
    localStorage.setItem('postLoginUrl', window.location.href)
    // window.location = '/login'
  }
})
